export { default } from './NProgress'